import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';
import { buttonsV2 as Buttons } from '@breezeway/brzw-components';

import { CALENDAR_THEMES } from '../../constants';
import './heading.scss';

const {
  BUTTON_THEMES: { LINK_PRIMARY },
  BUTTON_SIZES: { XSMALL: BUTTON_XSMALL },
} = Buttons.constants;

class Heading extends Component {
  constructor(props) {
    super(props);

    this.CLASS_NAME = 'brzw-calendar-heading';
  }

  renderSecondary() {
    const { onDayLinkClick, secondary } = this.props;

    const isDayClickFunction = _.isFunction(onDayLinkClick);

    if (secondary) {
      const text = (
        <span
          className={classnames(`${this.CLASS_NAME}__secondary`, {
            [`${this.CLASS_NAME}__secondary--link`]: isDayClickFunction,
          })}
        >
          {secondary}
        </span>
      );

      if (isDayClickFunction) {
        return (
          <Buttons.TextButton
            fullWidth
            onClick={onDayLinkClick}
            size={BUTTON_XSMALL}
            theme={LINK_PRIMARY}
          >
            {text}
          </Buttons.TextButton>
        );
      }

      return text;
    }

    return null;
  }

  render() {
    const { containerClassName, primary, theme } = this.props;

    return (
      <div
        className={classnames(this.CLASS_NAME, containerClassName, {
          [`${this.CLASS_NAME}--theme-${theme}`]: theme,
        })}
      >
        <span className={`${this.CLASS_NAME}__primary`}>{primary}</span>

        {this.renderSecondary()}
      </div>
    );
  }
}

Heading.propTypes = {
  containerClassName: PropTypes.string,
  onDayLinkClick: PropTypes.func,
  primary: PropTypes.string,
  secondary: PropTypes.string,
  theme: PropTypes.oneOf(_.values(CALENDAR_THEMES)),
};

Heading.defaultProps = {
  containerClassName: '',
  onDayLinkClick: null,
  primary: '',
  secondary: '',
  theme: CALENDAR_THEMES.PRIMARY,
};

export default Heading;
